import Button from 'devextreme-react/button'
import DataGrid, {
    Column, FilterRow, HeaderFilter, Pager, Paging, Scrolling, Sorting, Toolbar
} from 'devextreme-react/data-grid'
import LoadPanel from 'devextreme-react/load-panel'
import notify from 'devextreme/ui/notify'
import React, {useEffect, useState} from 'react'
import {getPointsTreePlain} from '../../api/dogovor'
import {getReads, getToken, getTokenUk} from '../../api/point'
import {notifyIsueAuthFail} from '../../utils/isue-notify'
import {useAuth} from '../../contexts/auth'
import {usePeriod} from '../../contexts/period'
import {getPoints} from '../../services/point.service'
import PopupPointsTreeHook from '../points-tree/popup-point-tree-hook'
import SelectPeriod from '../select-period/select-period'
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
import TreeHook from "../points-tree/tree-hook";
import {useScreenSize} from "../../utils/media-query";
import {Item} from "devextreme-react/toolbar";
import "./reads-grid.scss"
const ReadsGrid = (props) => {

    const pageSizes = [10, 25, 50, 100]
    let filename = 'История показаний'
    const [loading, setLoading] = useState(false)
    const [dataReads, setDataReads] = useState([])
    const [isPointsSelected, setIsPointsSelected] = useState(false)
    const [selectedObjects, setSelectedObjects] = useState([])
    const [btnClicked, setBtnClicked] = useState(false)
    const { periodStart, periodEnd } = usePeriod()
    const [points, setPoints] = useState(null)
    const { selectedDog } = useAuth()
    const typeReads = props.type
    const PRIEM_HISTORY = typeReads === 'PRIEM_HISTORY'
    const pointsType = 'all'//'integral'
    let { isLarge } = useScreenSize();
    const [loadingVisibleTreeHook, setloadingVisibleTreeHook] = useState(false)
    const dataGridRef = React.useRef(null);
    const [disabledIsue, setDisabledIsue] = useState(true)
    const isuOrIsue = process.env.REACT_APP_NAME_ENV !== 'renergy' ? "Э" : ""
    const envRenegy = process.env.REACT_APP_NAME_ENV === 'renergy'

    useEffect(() => {
        (async function () {
            setloadingVisibleTreeHook(true)
            setPoints(null)
            //получаем точки по договору
            const res = await getPointsTreePlain(selectedDog.kodDog, pointsType)
            if (res.isOk) {
                setPoints(res.data)
            } else {
                notify(res.message, 'error', 5000)
            }
            setloadingVisibleTreeHook(false)
         })()
    }, [selectedDog])

    useEffect(() => {
        setDataReads([])
        //setIsPointsSelected(false)
    }, [typeReads, selectedDog])

    const onTreeSelect = async (mas) => {
        // не выбраны точки или выбран головной объект но не УК
        setDisabledIsue(mas.length === 0)
        const points = getPoints(mas)
        setIsPointsSelected(points.length > 0)
        setSelectedObjects(mas)
        if (btnClicked) setBtnClicked(false)
    }

    const getReadsInfo = async () => {
        setBtnClicked(true)
        setLoading(true)

        const points = getPoints(selectedObjects)
        if (points.length > 0) {
            const reads = await getReads(points,periodStart,periodEnd,typeReads)
            if (reads.isOk) setDataReads(reads.data)
            else notify(reads.message, 'error', 5000)
        } else setDataReads([])

        setLoading(false)
    }

    const onExporting = () => {
        const dataGrid = dataGridRef.current.instance;
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('История показаний');

        exportDataGrid({
            component: dataGrid,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename + '.xlsx');
            });
        });
    };

    const onIsue = async () => {
        setLoading(true)
        if (selectedObjects.length > 0) {
            let resToken
            if (+selectedDog.parameter_uk !== 1) {
                if (selectedObjects[0].isG) {
                    //если головной объект берем первый после головного
                    resToken = await getToken(selectedObjects[1].id.split('_')[1])
                } else {
                    resToken = await getToken(selectedObjects[0].id.split('_')[1])
                }
            } else {
                resToken = await getTokenUk(selectedObjects[0].id.split('_')[0])
            }//'885b2c35-8547-4946-8a7d-20c47df8a0c9'
            if (resToken.isOk) {
                let json = resToken.data
                if (json.hasOwnProperty('token')){
                    window.open(json.url + json.token, '_blank');
                } else {
                    notifyIsueAuthFail({message: 'Объект не содержит token'}, 'point')
                }
            } else {
                notifyIsueAuthFail(resToken, 'point')
            }
        } else notify('Не выбран объект', 'error', 3000)
        setLoading(false)
    }

    return (
        <div className="row mt20">
            {!isLarge ?
                <div className="col-md-12">
                    <PopupPointsTreeHook
                        points={points}
                        onSelect={onTreeSelect}
                        typePoints={'all'}
                        selectionMode="multiple"
                        onShow={getReadsInfo}
                        showDisabled={!isPointsSelected}
                    />
                </div>
                :
                <div className="col-lg-3" id='tree-hook'>
                    <LoadPanel position={{ of: '#tree-hook' }} visible={loadingVisibleTreeHook}/>
                    <TreeHook points={points} onSelect={onTreeSelect}  typePoints={'all'} selectionMode="multiple"/>
                </div>
            }
            <div id='form-container' className={(!isLarge ? "col-md-12" : "col-9") + " mt20lgx tree-hook-left"}>
                {/*<div className="row mb-4" style={{alignItems: 'baseline'}}>
                    <SelectPeriod mode={'multiple'}/>
                    {isLarge &&
                    <div className="col-lg-3 col-md-3 col-sm-5 col-xs-12 mt20md mt20xs" style={{minWidth: '200px'}}>
                        <Button className="w-100" disabled={!isPointsSelected} text="Показать" type='default' hint="Показать" icon="refresh" onClick={getReadsInfo} />
                    </div>
                    }
                    <div className="col-lg-3 col-md-3 col-sm-5 col-xs-12 mt20md mt20xs" style={{minWidth: '200px'}}>
                        <Button icon='xlsfile' className='w-100' text='Выгрузить в Excel' hint='Выгрузить в Excel' onClick={onExporting} />
                    </div>
                    {['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV) &&
                    <div className="col-lg-3 col-md-4 col-sm-5 col-xs-12 mt20md mt20xs" style={{minWidth: '260px'}}>
                        <Button disabled={disabledIsue} className='w-100' text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                icon="refresh" onClick={onIsue}/>
                    </div>
                    }
                </div>*/}
                    <div className="row">
                        <div className="col-md-12 reads-grid">
                            <div>
                                        <DataGrid
                                            ref={dataGridRef}
                                            id={'pokazania-history'}
                                            dataSource={dataReads}
                                            keyExpr="id_row"
                                            columnHidingEnabled={false}
                                            allowColumnReordering={true}
                                            rowAlternationEnabled={true}
                                            showBorders={true}
                                            noDataText='Выберите точки учета и нажмите «Показать»'//"Для выбранных параметров нет данных"
                                            wordWrapEnabled={true}
                                            allowColumnResizing={true}
                                            columnWidth={'auto'}
                                            width={'100%'}
                                        >
                                            <Scrolling columnRenderingMode="virtual" />
                                            <Paging defaultPageSize={12} />
                                            <Pager
                                                visible={true}
                                                allowedPageSizes={[5, 12, 20, 'all']}
                                                displayMode={'full'}
                                                showPageSizeSelector={true}
                                                showInfo={true}
                                                showNavigationButtons={true} />
                                            <Sorting mode="multiple" />
                                            <FilterRow
                                                visible={true} />
                                            <HeaderFilter visible={true} />
                                            <Toolbar>
                                                <Item location="before" widget="dxButton" locateInMenu="auto" >
                                                    <SelectPeriod mode={'multiple-toolbar1'}/>
                                                </Item>
                                                <Item location="before" widget="dxButton" locateInMenu="auto" >
                                                    <SelectPeriod mode={'multiple-toolbar2'}/>
                                                </Item>
                                                <Item visible={isLarge} location="before" widget="dxButton" locateInMenu="never" >
                                                    <Button disabled={!isPointsSelected} text="Показать" type='default' hint="Показать" icon="refresh" onClick={getReadsInfo} />
                                                </Item>
                                                <Item location="after" widget="dxButton" locateInMenu="auto" >
                                                    <Button icon='xlsfile' className='w-100' text='Выгрузить в Excel' hint='Выгрузить в Excel' onClick={onExporting} />
                                                </Item>
                                                <Item visible={['tatenergosbyt', 'renergy'].includes(process.env.REACT_APP_NAME_ENV)} location="after" widget="dxButton" locateInMenu="auto" >
                                                    <Button disabled={disabledIsue} className='w-100' text={`Данные ИСУ${isuOrIsue}`} hint="Переход в Интеллектуальную Систему Учета Электроэнергии (ИСУЭ)"
                                                            icon="refresh" onClick={onIsue}/>
                                                </Item>
                                            </Toolbar>
                                            <Column dataField="period" caption="Период" format="yyyy.MM" dataType="date" width={120} visibleIndex={0} />
                                            <Column dataField="dat_priem" caption="Дата показаний" dataType="date" width={120} visible={!envRenegy} visibleIndex={1} />
                                            <Column dataField="num_pu" caption="№ прибора" dataType="string" width={120} visibleIndex={envRenegy ? 1 : 2} />
                                            <Column dataField="en_direct" caption="Вид энергии" dataType="string" width={90} visibleIndex={envRenegy ? 2 : 3} />
                                            <Column dataField="name" caption={envRenegy ? "Место установки" : "Название ТУ"} dataType="string" width={250} visibleIndex={envRenegy ? 3 : 4} />
                                            <Column dataField="nomer" caption="№ ТУ" dataType="string" width={100} visible={!envRenegy} visibleIndex={5} />
                                            <Column dataField="readlast" caption="Показание" dataType="string" width={120} visibleIndex={envRenegy ? 4 : 6} />
                                            <Column dataField="out" caption="Расход, кВтч" dataType="string" width={100} visible={PRIEM_HISTORY} visibleIndex={envRenegy ? 5 : 7} />
                                            <Column dataField="outadd" caption="Доп. расход, кВтч" dataType="string" visibleIndex={envRenegy ? 6 : 8} />
                                            <Column dataField="pot_fix" caption="Потери, кВтч" dataType="number" visible={PRIEM_HISTORY} visibleIndex={envRenegy ? 7 : 9} />
                                            <Column dataField="pot_prc" caption="Потери (%)" dataType="number" visible={!envRenegy && PRIEM_HISTORY} visibleIndex={10} />
                                            <Column dataField="name_obj" caption="Наименование объекта" dataType="string" width={100} visible={envRenegy} visibleIndex={8} />
                                            <Column dataField="address_obj" caption="Адрес объекта" dataType="string" width={100} visible={envRenegy} visibleIndex={9} />
                                            <Column dataField="num_obj" caption="Номер объекта" dataType="string" width={100} visible={envRenegy} visibleIndex={10} />
                                            <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                            <Paging defaultPageSize={10} />
                                        </DataGrid>
                                        <LoadPanel visible={loading} />
                                    </div>
                        </div>
                    </div>
            </div>
        </div>

    )
}

export default ReadsGrid
